(() => {
  // ---------- HELPERS ----------
  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));

  // ---------- PAGE FLAGS ----------
  function isServicesPage() {
    return window.location.pathname === '/pages/services';
  }

  // ---------- ACTIVE LINK BORDER (DESKTOP NAV) ----------
  function initActiveNavBorder() {
    const navContainer = $('[data-wb-desktop-nav]');
    if (!navContainer) return;

    const currentPath = window.location.pathname;
    const navLinks = $$('.wb-nav-link', navContainer);
    const useWhite = isServicesPage();

    let hasActive = false;

    navLinks.forEach((link) => {
      const targetPath = link.getAttribute('href');
      if (!targetPath) return;

      const dropdown = link.closest('[data-wb-dropdown]');
      let isActive = false;

      // 1) Lien principal
      if (
        currentPath === targetPath ||
        (targetPath !== '/' && currentPath.startsWith(targetPath))
      ) {
        isActive = true;
      }

      // 2) Liens enfants (si dropdown)
      if (!isActive && dropdown) {
        const subLinks = dropdown.querySelectorAll('a');
        subLinks.forEach((child) => {
          const childHref = child.getAttribute('href');
          if (childHref === currentPath) isActive = true;
        });
      }

      // 3) Styles actifs
      if (isActive) {
        hasActive = true;

        link.classList.remove('border-transparent');
        link.classList.add(useWhite ? 'border-white' : 'border-black');

        if (dropdown) {
          const iconPart = $('.wb-nav-link-icon', dropdown);
          if (iconPart) {
            iconPart.classList.remove('border-transparent');
            iconPart.classList.add(useWhite ? 'border-white' : 'border-black');
          }
        }
      }
    });

    // FALLBACK : si rien trouvé, on active le premier lien
    if (!hasActive && navLinks.length > 0) {
      const firstLink = navLinks[0];
      const firstDropdown = firstLink.closest('[data-wb-dropdown]');

      firstLink.classList.remove('border-transparent');
      firstLink.classList.add(useWhite ? 'border-white' : 'border-black');

      if (firstDropdown) {
        const firstIcon = $('.wb-nav-link-icon', firstDropdown);
        if (firstIcon) {
          firstIcon.classList.remove('border-transparent');
          firstIcon.classList.add(useWhite ? 'border-white' : 'border-black');
        }
      }
    }
  }

  // ---------- /pages/services THEME (WHITE) ----------
  function initServicesHeaderTheme() {
    if (!isServicesPage()) return;

    const header = $('#site-header');
    if (!header) return;

    // Texte global blanc (burger inclus via currentColor)
    header.classList.add('text-white');

    // Force blanc sur éléments qui ont text-black / border-black dans le markup
    const forceWhite = (el) => {
      el.classList.remove('text-black');
      el.classList.add('text-white');

      if (el.classList.contains('border-black')) {
        el.classList.remove('border-black');
        el.classList.add('border-white');
      }
    };

    const desktopNav = $('[data-wb-desktop-nav]', header);
    if (desktopNav) {
      // wrappers dropdown (ex: "relative text-black ...")
      $$('[data-wb-dropdown]', desktopNav).forEach(forceWhite);

      // liens
      $$('.wb-nav-link', desktopNav).forEach((a) => {
        a.classList.remove('text-black');
        a.classList.add('text-white');

        if (a.classList.contains('border-black')) {
          a.classList.remove('border-black');
          a.classList.add('border-white');
        }
      });

      // icônes dropdown
      $$('.wb-nav-link-icon', desktopNav).forEach((el) => {
        el.classList.remove('text-black');
        el.classList.add('text-white');

        if (el.classList.contains('border-black')) {
          el.classList.remove('border-black');
          el.classList.add('border-white');
        }
      });
    }

    // Burger
    const burgerBtn = $('[data-wb-menu-toggle]', header);
    if (burgerBtn) {
      burgerBtn.classList.remove('text-black');
      burgerBtn.classList.add('text-white');
    }
  }

  // ---------- HEADER SCROLL / SHRINK ----------
  function isPagesSection() {
    const p = window.location.pathname;
    return p.includes('/pages/') || p === '/pages' || p.startsWith('/pages/');
  }

  function handleHeaderScroll() {
    const header = $('#site-header');
    if (!header) return;

    const shrinkElements = $$('[data-wb-shrink]');
    const threshold = window.innerHeight * (isPagesSection() ? 0.9 : 1.9);
    const scrolledPast = window.scrollY > threshold;

    shrinkElements.forEach((el) => {
      if (scrolledPast) {
        el.classList.add('opacity-0', 'pointer-events-none', 'invisible');
        el.style.maxWidth = '0px';
        el.style.overflow = 'hidden';
      } else {
        el.classList.remove('opacity-0', 'pointer-events-none', 'invisible');
        el.style.maxWidth = '';
        el.style.overflow = '';
      }
    });

    // ✅ Header toujours transparent : pas de toggle bg
  }

  // ---------- MOBILE DRAWER (BURGER) ----------
  function initMobileDrawer() {
    const drawer = $('[data-wb-drawer]');
    if (!drawer) return;

    const openBtns = $$('[data-wb-menu-toggle]');
    const closeBtns = $$('[data-wb-menu-close]');

    const openDrawer = () => {
      // On affiche la modale (on retire les blocages)
      // Calculer la largeur de la scrollbar avant de la cacher
  const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
  
  // Appliquer le padding pour compenser la disparition
  document.body.style.paddingRight = `${scrollbarWidth}px`;
  document.documentElement.classList.add('overflow-hidden');

  drawer.classList.remove('pointer-events-none', 'invisible', '-translate-y-full', 'opacity-0');
  drawer.classList.add('translate-y-0', 'opacity-100');
      drawer.classList.remove('pointer-events-none', 'invisible', '-translate-y-full', 'opacity-0'); // On force la position finale (en haut de l'écran)
      drawer.classList.add('translate-y-0', 'opacity-100');

      drawer.setAttribute('aria-hidden', 'false');
      openBtns.forEach((b) => b.setAttribute('aria-expanded', 'true'));
      document.documentElement.classList.add('overflow-hidden');
    };

    const closeDrawer = () => {
      // On lance l'animation de remontée
      drawer.classList.add('-translate-y-full', 'opacity-0');
      drawer.classList.remove('translate-y-0', 'opacity-100');

      // ATTENTION : Le délai ici doit être identique à la duration CSS (700ms)
      setTimeout(() => {
        // On vérifie que le drawer est toujours censé être fermé avant de le cacher complètement
        if (drawer.classList.contains('-translate-y-full')) {
          drawer.classList.add('pointer-events-none', 'invisible');
        }
      }, 3000);

      drawer.setAttribute('aria-hidden', 'true');
      openBtns.forEach((b) => b.setAttribute('aria-expanded', 'false'));
      document.documentElement.classList.remove('overflow-hidden');

      setTimeout(() => {
    // Remettre à zéro après l'animation
    document.body.style.paddingRight = '';
    document.documentElement.classList.remove('overflow-hidden');
  }, 700);
    };

    openBtns.forEach((btn) =>
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        openDrawer();
      })
    );

    closeBtns.forEach((btn) =>
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        closeDrawer();
      })
    );

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') closeDrawer();
    });
  }

  // ---------- INIT ----------
  function init() {
    initServicesHeaderTheme(); // thème spécial /pages/services (text/borders)
    initActiveNavBorder(); // bordure active (blanche sur services)
    initMobileDrawer();

    window.addEventListener('scroll', handleHeaderScroll, { passive: true });
    window.addEventListener('load', handleHeaderScroll);
    window.addEventListener('pageshow', handleHeaderScroll);
    handleHeaderScroll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();


document.addEventListener('DOMContentLoaded', () => {
  const burger = document.getElementById('mobile-burger-button');
  const sectionBeyond = document.getElementById('beyond');

  if (burger && sectionBeyond) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          // Quand on arrive sur la section #beyond
          burger.classList.remove('text-white');
          burger.classList.add('text-black');
        } else {
          // Quand on sort de la section (retour au style par défaut)
          burger.classList.remove('text-black');
          burger.classList.add('text-white');
        }
      });
    }, {
      threshold: 0.1 // Déclenche dès que 10% de la section est visible
    });

    observer.observe(sectionBeyond);
  }
});